export default __webpack_public_path__ + "static/media/generic-school.321ec7b2.svg";